var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsintOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(-1039 -468)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(1039 468)",
    fill: "#558849"
  }), /*#__PURE__*/React.createElement("text", {
    id: "OSINT",
    transform: "translate(1053 486)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OSINT")), /*#__PURE__*/React.createElement("text", {
    id: "OS",
    transform: "translate(1048 528)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsintOs);
export default __webpack_public_path__ + "static/media/osintOS.baeb9bb3bbe02ec3a9ef19330963caad.svg";
export { ForwardRef as ReactComponent };